var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[(this.image)?_c('div',{staticClass:"header",style:(_vm.backgroundImage)}):_vm._e(),(_vm.renderProgressBar)?_c('Progress',{attrs:{"questions":this.progress_questions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }